import CreateCurrencies from './CreateCurrency';
export default CreateCurrencies;
